import React from 'react';
import PropTypes from 'prop-types';

import OEToolbox from '../tools/oe-toolbox';
import {ScreenOrientationMainType, ScreenOrientation} from '../screen-orientation';

export const OEVHLayoutType = {
    horizontal:         'horizontal',
    vertical:           'vertical',
    std:                'horizontal'
};

OEVHLayoutType.all = [
    OEVHLayoutType.horizontal,
    OEVHLayoutType.vertical
];

export class OEVHLayouter extends React.PureComponent {
    
    constructor(props) {
        super(props);

        this.screenOrientation = ScreenOrientation.getMainType();

        this.layoutType = this.determineLayoutType();

        this.onScreenOrienationChanged = this.onScreenOrienationChanged.bind(this);
    }

    componentWillReceiveProps(nextProps) {
        if(!OEToolbox.shallowEqual(nextProps.allowedLayoutTypes, this.props.allowedLayoutTypes, false) || nextProps.determineLayoutType != this.props.determineLayoutType || nextProps.defaultLayoutType != this.props.defaultLayoutType)    {
            this.updateLayoutType(nextProps);
        }

        if(nextProps.onLayoutTypeChanged !== this.props.onLayoutTypeChanged && nextProps.onLayoutTypeChanged)   {
            nextProps.onLayoutTypeChanged(this, this.layoutType);
        }
    }

    componentDidMount()    {
        ScreenOrientation.registerChangeListener(this.onScreenOrienationChanged);
        this.updateScreenOrientation();
        if(this.props.onLayoutTypeChanged)  this.props.onLayoutTypeChanged(this, this.layoutType);
    }

    componentWillUnmount()    {
        ScreenOrientation.unregisterChangeListener(this.onScreenOrienationChanged);
    }

    updateScreenOrientation()   {
        if(this.screenOrientation === ScreenOrientation.getMainType())  return;
        this.screenOrientation == ScreenOrientation.getMainType();
        this.updateLayoutType();
    }

    onScreenOrienationChanged(event)    {
        if(this.screenOrientation === event.mainType)   return;
        this.screenOrientation = event.mainType;
        this.updateLayoutType();
    }

    determineLayoutType(props)  {
        props = props || this.props;

        if(props.determineLayoutType)   {
            layout = props.determineLayoutType(this, props.allowedLayoutTypes, props.defaultLayoutType);
            return layout ? layout : props.defaultLayoutType;
        }

        if(!props.allowedLayoutTypes.length) return props.defaultLayoutType;
        if(props.allowedLayoutTypes.length == 1) return props.allowedLayoutTypes[0];

        let recommedLayouts = [props.defaultLayoutType];

        if(bowserTool.mobile || bowserTool.tablet)   {
            if(this.screenOrientation === ScreenOrientationMainType.landscape)  {
                recommedLayouts = [OEVHLayoutType.vertical, OEVHLayoutType.horizontal];
            }
        }

        recommedLayouts = recommedLayouts.filter(layout => props.allowedLayoutTypes.includes(layout));

        return recommedLayouts.length ? recommedLayouts[0] : props.defaultLayoutType;
    }

    updateLayoutType(props) {
        props = props || this.props;
        
        let layoutType = this.determineLayoutType(props);
        if(this.layoutType === layoutType) return;

        this.layoutType = layoutType;
        if(props.onLayoutTypeChanged)  props.onLayoutTypeChanged(this, this.layoutType);
    }

    render() {
        return null;
    }
};

OEVHLayouter.defaultProps = {
    allowedLayoutTypes: OEVHLayoutType.all,
    defaultLayoutType: OEVHLayoutType.std
};

OEVHLayouter.propTypes = {
    allowedLayoutTypes: PropTypes.arrayOf(PropTypes.oneOf(OEVHLayoutType.all)),
    defaultLayoutType: PropTypes.oneOf(OEVHLayoutType.all),
    determineLayoutType: PropTypes.func,
    onLayoutTypeChanged: PropTypes.func
};